import { IButtonFilterTypes, type IButtonFilters } from '@/domains/career/main/components/career-main-benefits/career-main-benefits.types'

export const BUTTONS_FILTERS: IButtonFilters[] = [
  { text: 'career.benefits.filters.all', value: IButtonFilterTypes.ALL },
  { text: 'career.benefits.filters.health', value: IButtonFilterTypes.HEALTH },
  { text: 'career.benefits.filters.finance', value: IButtonFilterTypes.FINANCE },
  { text: 'career.benefits.filters.learning', value: IButtonFilterTypes.LEARNING },
  { text: 'career.benefits.filters.other', value: IButtonFilterTypes.OTHER },
]
